import { APP_INITIALIZER, ApplicationConfig, ErrorHandler, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, Router } from '@angular/router';

import { routes } from './app.routes';
import { UnwrapInterceptor } from './api/helpers/UnwrapInterceptor';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideIonicAngular } from '@ionic/angular/standalone';

import {provideTranslateService, TranslateLoader} from "@ngx-translate/core";
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {HttpClient} from '@angular/common/http';
import { AuthInterceptor } from './api/helpers/AuthInterceptor';
import * as Sentry from "@sentry/angular"
import {GlobalErrorHandler} from './services/errorHandler/GlobalErrorHandler';
import {provideCharts, withDefaultRegisterables} from 'ng2-charts';
import { ErrorInterceptor } from './api/helpers/ErrorInterceptor';
import {LanguageService} from './services/language/language.service';

const httpLoaderFactory: (http: HttpClient) => TranslateHttpLoader = (http: HttpClient) =>
    new TranslateHttpLoader(http, './i18n/', '.json');

export const appConfig: ApplicationConfig = {
      providers: [
            {
                  provide: ErrorHandler,
                  useValue: Sentry.createErrorHandler(),
            },
            {
                  provide: Sentry.TraceService,
                  deps: [Router],
            },
            {
                  provide: APP_INITIALIZER,
                  useFactory: () => () => {},
                  deps: [Sentry.TraceService],
                  multi: true,
            },
            {
                  provide: APP_INITIALIZER,
                  useFactory: (langService: LanguageService) => () => langService.init(),
                  deps: [LanguageService],
                  multi: true,
            },
            {
                  provide: ErrorHandler,
                  useClass: GlobalErrorHandler
            },
            provideCharts(withDefaultRegisterables()),
            provideZoneChangeDetection({ eventCoalescing: true }),
            provideRouter(routes),
            provideHttpClient(
                withInterceptors([UnwrapInterceptor, AuthInterceptor, ErrorInterceptor]),
            ),
            provideAnimationsAsync(),
            provideIonicAngular({
                mode: 'md'
            }),
            provideTranslateService({
                  loader: {
                    provide: TranslateLoader,
                    useFactory: httpLoaderFactory,
                    deps: [HttpClient],
                  },
                  defaultLanguage: 'nl',
            })
      ]
};
